const cards = [
  {
    title: '绝世武神',
    type: '玄幻 · 韩漫',
    desc: '少年林风意外获得上古传承，从此踏上逆天修行之路。热血升级，快意恩仇！',
    image: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20fantasy%20manga%20cover%20style%20illustration%20with%20a%20young%20warrior%20in%20traditional%20Chinese%20robes%2C%20glowing%20golden%20energy%20aura%2C%20dramatic%20wind%20effects%2C%20warm%20orange%20and%20gold%20color%20palette%2C%20clean%20background%2C%20anime%20art%20style%2C%20high%20detail%2C%20professional%20cover%20design&width=500&height=650&seq=card-1-martial&orientation=portrait',
  },
  {
    title: '甜蜜暴击',
    type: '恋爱 · 国漫',
    desc: '高冷校草遇上元气少女，从互相看不顺眼到心动沦陷的甜蜜恋爱故事。',
    image: 'https://readdy.ai/api/search-image?query=A%20sweet%20romance%20manga%20cover%20style%20illustration%20with%20a%20cute%20couple%20in%20school%20uniforms%2C%20soft%20pink%20and%20warm%20peach%20color%20palette%2C%20sparkling%20cherry%20blossom%20petals%2C%20gentle%20lighting%2C%20clean%20simple%20background%2C%20anime%20art%20style%2C%20high%20detail%2C%20professional%20cover%20design&width=500&height=650&seq=card-2-sweet&orientation=portrait',
  },
  {
    title: '炎之轨迹',
    type: '热血 · 日漫',
    desc: '在火焰与刀光的世界里，少年剑客为守护挚友而战，燃尽一切黑暗！',
    image: 'https://readdy.ai/api/search-image?query=A%20fiery%20action%20manga%20cover%20style%20illustration%20with%20a%20swordsman%20surrounded%20by%20flames%2C%20dynamic%20pose%2C%20intense%20orange%20and%20red%20color%20palette%2C%20dramatic%20lighting%2C%20clean%20dark%20background%2C%20anime%20art%20style%2C%20high%20detail%2C%20professional%20cover%20design&width=500&height=650&seq=card-3-flame&orientation=portrait',
  },
  {
    title: '暗夜侦探录',
    type: '悬疑 · 国漫',
    desc: '天才侦探少女破解连环谜案，每一话都是智商与勇气的双重考验。',
    image: 'https://readdy.ai/api/search-image?query=A%20mystery%20manga%20cover%20style%20illustration%20with%20a%20female%20detective%20in%20a%20trenchcoat%2C%20moody%20amber%20lighting%2C%20shadows%20and%20silhouettes%2C%20warm%20dark%20tones%2C%20noir-inspired%20anime%20art%20style%2C%20clean%20simple%20background%2C%20high%20detail%2C%20professional%20cover%20design&width=500&height=650&seq=card-4-detective&orientation=portrait',
  },
  {
    title: '重生之都市仙尊',
    type: '穿越 · 韩漫',
    desc: '仙界至尊陨落重生都市，以万古修为碾压一切，开启逆天改命的传奇。',
    image: 'https://readdy.ai/api/search-image?query=A%20reincarnation%20fantasy%20manga%20cover%20style%20illustration%20with%20a%20powerful%20figure%20split%20between%20ancient%20immortal%20realm%20and%20modern%20city%2C%20golden%20energy%20effects%2C%20warm%20orange%20and%20coral%20tones%2C%20dramatic%20composition%2C%20anime%20art%20style%2C%20high%20detail%2C%20professional%20cover%20design&width=500&height=650&seq=card-5-rebirth&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">热门漫画</h2>
          <p className="text-sm text-foreground-500">万人追更的热门漫画精选</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4" data-product-shop="">
          {cards.map((item) => (
            <div key={item.title} className="group flex flex-col rounded-xl overflow-hidden bg-background-100 cursor-pointer">
              <div className="relative overflow-hidden" style={{ aspectRatio: '3/4' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-bold text-foreground-800 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-1">{item.type}</p>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}